<mat-toolbar class="container announcement-bar-content m-auto">
  <div class="d-flex align-items-start justify-content-between w-100">
    <ng-content></ng-content>
    <ala-social-links class="d-flex ml-auto social-links"></ala-social-links>
  </div>
</mat-toolbar>